"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPhoneAid = void 0;

var React = __importStar(require("react"));

exports.IconPhoneAid = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "18",
    height: "32",
    viewBox: "0 0 18 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50001 1L14.5 0.999999C15.1972 0.999999 15.6775 1.11653 16.0108 1.28315C16.3366 1.44604 16.5448 1.66799 16.6861 1.92693C16.9888 2.48193 17 3.21905 17 4V4.5H1.00001L1.00001 4C1.00001 3.49287 1.00061 3.05358 1.04383 2.66459C1.08684 2.27754 1.16842 1.98282 1.30376 1.75725C1.54368 1.35737 2.06649 1 3.50001 1ZM0.00180902 3.5C0.00545722 3.17512 0.0165056 2.85512 0.049946 2.55416C0.10069 2.09746 0.206608 1.64218 0.446266 1.24275C0.956342 0.392626 1.93354 0 3.50001 0H14.5C15.3028 0 15.9475 0.133467 16.458 0.388723C16.976 0.647707 17.3302 1.01951 17.564 1.44807C17.915 2.09167 17.9836 2.85409 17.9969 3.5H18V3.84199L18 3.94846L18 4V28L18 28.0584L18 28.179V28.5H17.9974C17.9854 29.1749 17.9195 29.9494 17.5621 30.5928C17.0699 31.4787 16.1128 32 14.5 32V31.5V31C15.8872 31 16.4301 30.5713 16.6879 30.1072C16.988 29.5671 17 28.8348 17 28V26H1.00001V28C1.00001 28.781 1.01123 29.5181 1.31396 30.0731C1.4552 30.332 1.66346 30.554 1.98924 30.7168C2.32248 30.8835 2.80285 31 3.50001 31H10.125H13.2031L14.1504 31H14.4094H14.477H14.4942H14.4986H14.4996H14.4999L14.5 31.5L14.4999 32H14.4996H14.4986H14.4942H14.477H14.4094H14.1504H13.2031H10.125H3.50001C2.69718 32 2.05254 31.8665 1.54203 31.6113C1.02406 31.3523 0.669825 30.9805 0.436065 30.5519C0.0850125 29.9083 0.0164039 29.1459 0.00313127 28.5H1.25721e-05V28.1589L0 28.0515L1.25721e-05 28V3.5H0.00180902ZM1.00001 5.5V25H17V5.5H1.00001ZM6.50001 28C6.22387 28 6.00001 28.2239 6.00001 28.5C6.00001 28.7761 6.22387 29 6.50001 29H11.5C11.7762 29 12 28.7761 12 28.5C12 28.2239 11.7762 28 11.5 28H6.50001ZM7.50098 10C7.50098 9.72386 7.72483 9.5 8.00098 9.5H10.001C10.2771 9.5 10.501 9.72386 10.501 10V13.5H14.001C14.2771 13.5 14.501 13.7239 14.501 14V16C14.501 16.2761 14.2771 16.5 14.001 16.5H10.501V20C10.501 20.2761 10.2771 20.5 10.001 20.5H8.00098C7.72483 20.5 7.50098 20.2761 7.50098 20V16.5H4.00098C3.72483 16.5 3.50098 16.2761 3.50098 16V14C3.50098 13.7239 3.72483 13.5 4.00098 13.5H7.50098V10Z",
    fill: color
  }));
});